(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vb-faq-item"] && !Shopify.designMode) return;
  try {
    // Escape closes the open answer that holds focus and returns focus to its question.
  // Native <details> already handles Tab, Enter and Space; this is the only key it lacks.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const target = event.target instanceof Element ? event.target : null;
    const item = target?.closest('details.vb-faq-item[open]');
    if (!item) return;
    item.open = false;
    item.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
